// Browser-compatible logger for client-side React app
// Mimics Winston API but uses browser console

const logger = {
  info: (message, ...args) => {
    const timestamp = new Date().toISOString().replace('T', ' ').substring(0, 19);
    console.log(`${timestamp} [patient-simulation-client] INFO: ${message}`, ...args);
  },
  
  error: (message, ...args) => {
    const timestamp = new Date().toISOString().replace('T', ' ').substring(0, 19);
    console.error(`${timestamp} [patient-simulation-client] ERROR: ${message}`, ...args);
  },
  
  warn: (message, ...args) => {
    const timestamp = new Date().toISOString().replace('T', ' ').substring(0, 19);
    console.warn(`${timestamp} [patient-simulation-client] WARN: ${message}`, ...args);
  },
  
  debug: (message, ...args) => {
    const timestamp = new Date().toISOString().replace('T', ' ').substring(0, 19);
    console.debug(`${timestamp} [patient-simulation-client] DEBUG: ${message}`, ...args);
  }
};

export default logger;